import React from 'react';
import styled from '@emotion/styled';

const Loading = () => {
  return (
    <Background>
      <CubeContainer>
        <Cube>
          <div />
          <div />
          <div />
          <div />
          <div />
          <div />
        </Cube>
      </CubeContainer>
      <LoadingText>Loading...</LoadingText>
    </Background>
  );
};
const CubeContainer = styled.div`
  display: flex;
  position: relative;
  align-items: center;
  -ms-flex-pack: center;
  justify-content: center;
  height: 128px;
  overflow: hidden;
  width: 100%;
`;
const Cube = styled.div`
  -webkit-animation: cube 2s infinite ease;
  animation: cube 2s infinite ease;
  height: 40px;
  -webkit-transform-style: preserve-3d;
  transform-style: preserve-3d;
  width: 40px;

  div {
    background-color: #4d5ced;
    height: 100%;
    position: absolute;
    width: 100%;
    border: 2px solid white;
  }

  div:nth-of-type(1) {
    -webkit-transform: translateZ(-20px) rotateY(180deg);
    transform: translateZ(-20px) rotateY(180deg);
  }
  div:nth-of-type(2) {
    -webkit-transform: rotateY(-270deg) translateX(50%);
    transform: rotateY(-270deg) translateX(50%);
    -webkit-transform-origin: top right;
    transform-origin: top right;
  }
  div:nth-of-type(3) {
    -webkit-transform: rotateY(270deg) translateX(-50%);
    transform: rotateY(270deg) translateX(-50%);
    -webkit-transform-origin: center left;
    transform-origin: center left;
  }
  div:nth-of-type(4) {
    -webkit-transform: rotateX(90deg) translateY(-50%);
    transform: rotateX(90deg) translateY(-50%);
    -webkit-transform-origin: top center;
    transform-origin: top center;
  }
  div:nth-of-type(5) {
    -webkit-transform: rotateX(-90deg) translateY(50%);
    transform: rotateX(-90deg) translateY(50%);
    -webkit-transform-origin: bottom center;
    transform-origin: bottom center;
  }
  div:nth-of-type(6) {
    -webkit-transform: translateZ(20px);
    transform: translateZ(20px);
  }
  @-webkit-keyframes cube {
    0% {
      -webkit-transform: rotate(45deg) rotateX(-25deg) rotateY(25deg);
      transform: rotate(45deg) rotateX(-25deg) rotateY(25deg);
    }
    50% {
      -webkit-transform: rotate(45deg) rotateX(-385deg) rotateY(25deg);
      transform: rotate(45deg) rotateX(-385deg) rotateY(25deg);
    }
    100% {
      -webkit-transform: rotate(45deg) rotateX(-385deg) rotateY(385deg);
      transform: rotate(45deg) rotateX(-385deg) rotateY(385deg);
    }
  }
  @keyframes cube {
    0% {
      -webkit-transform: rotate(45deg) rotateX(-25deg) rotateY(25deg);
      transform: rotate(45deg) rotateX(-25deg) rotateY(25deg);
    }
    50% {
      -webkit-transform: rotate(45deg) rotateX(-385deg) rotateY(25deg);
      transform: rotate(45deg) rotateX(-385deg) rotateY(25deg);
    }
    100% {
      -webkit-transform: rotate(45deg) rotateX(-385deg) rotateY(385deg);
      transform: rotate(45deg) rotateX(-385deg) rotateY(385deg);
    }
  }
`;

const Background = styled.div`
  position: fixed;
  width: 100vw;
  height: 100%;
  top: 0;
  left: 0;
  background: #0c0909a6;
  opacity: 1;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const LoadingText = styled.div`
  text-align: center;
  font-size: 24px;
  font-weight: 800;
  color: white;
`;

export default Loading;
